import cn from "classnames";
import styles from "@/components/Game/Compass/Compass.module.sass";
import Image from "next/image";

import {Objects, useGameContext} from "@/context/GameContext";

const Chest = ({parentStyle, className, ...props}) => {

	const {isMobile} = useGameContext()

	return (
			<div className={cn(styles.chest, className)} {...props}>
				{/*Parchment*/}
				<Image className={cn(parentStyle.chest__image, 'chest__image')} src={"/images/Game/Chest/chest.png"} alt={"Chest"} id={Objects.CHEST} width={870} height={616}/>
				<Image className={parentStyle.chest__image_empty} src={'/images/Game/Chest/chest_empty.png'} alt={"Chest Empty"} width={870} height={616}/>

				{/*Sparkles*/}
				{isMobile !== undefined ? (isMobile ? <Image className={cn(parentStyle.chest__sparkles, 'chest__sparkles')} src={'/images/Game/Glow/sparkles.png'} alt={"Sparkles"} width={64} height={64} />
						: <Image className={cn(parentStyle.chest__sparkles, 'chest__sparkles')} src={'/images/Game/Glow/sparkles.gif'} alt={"Sparkles"} width={64} height={64}/>) : null}
			</div>
	);
}
export default Chest;